import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "onClick", "url"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
/* eslint-disable react/jsx-no-target-blank */
import * as React from 'react';
import * as styles from './Link.css';
import { jsx as _jsx } from "react/jsx-runtime";
export var Link = /*#__PURE__*/React.forwardRef(function Link(props, ref) {
  var children = props.children,
    onClick = props.onClick,
    url = props.url,
    htmlProps = _objectWithoutProperties(props, _excluded);
  var handleClick = React.useCallback(function (event) {
    if (!window || !location) {
      return;
    }
    event.preventDefault();
    if (onClick) {
      onClick();
    }
    window.open(url, '_blank', 'noopener');
  }, [onClick, url]);
  return /*#__PURE__*/_jsx("a", _objectSpread(_objectSpread({
    target: "_blank",
    rel: "noreferrer noopener",
    onClick: handleClick,
    href: url,
    className: styles['element'],
    ref: ref
  }, htmlProps), {}, {
    children: children
  }));
});